<script>
	import formBase from '@_system/components/base/form.vue'
	import onlinebox from './box/online.vue'
	import tradebox from './box/trade.vue'
	import reconciliation from './reconciliation/index.vue'
	import customerbox from '@/components/forms/offer/box/customer/list.vue'
	export default {
		extends: formBase,
		name: 'collectionForm',
		render(h) {
			this.$slots.plug = [
				// <
				// childrenorder ref = "childrenorderBack"
				// data = {
				// 	this.childrenorders
				// }
				// onBack = {
				// 	this.childrenorderBack
				// }
				// onSubmit = {
				// 	this.childrenorderSubmit
				// }
				// />, 
				<customerbox ref="customerbox" condition={this.condition} onSubmit={this.customerboxSubmit} onList={this.customerboxList} />,
				<reconciliation wlnorder = {this.wlnorder} ref = "reconciliation" />,
				<tradebox ref="tradebox" customerid={this.customerid} onSubmit={this.tradeboxSubmit}  />,
				<onlinebox ref="onlinebox" onSubmit={this.checkonlineSubmit}  />
			]
			return formBase.render.call(this, h)
		},
		props: {

		},
		data() {
			return {
				currentsalercpt_no: null,
				childrenorders: [],
				handle: null,
				hasauditorder: false,
				wlnorder: [],
				condition:null,
				customerid:null,	
				tradeboxHandle:null

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			customerboxList(e){
				let trade = e.trade
				if(trade){
					this.$refs.customerbox.modal_model = false
					trade.account = this.fApi.getValue('account')
					trade.collection_time = this.fApi.getValue('commit_time')
					trade.payman = this.fApi.getValue('invoicetitle')?this.fApi.getValue('invoicetitle'):'个人'
					trade.orderamount = trade.needamount				
					trade.autoaudit = 5
					let $son_collection_order = this.fApi.el('$son_collection_order')
					$son_collection_order.getGrid().insertAt(trade, -1)
				}

				
			},
			customerboxSubmit(e){
				if(e.data){
					let customercode = this.fApi.getValue('customercode')
					this.fApi.setValue('customerid',e.data.id)
					this.fApi.setValue('customercode',e.data.code)
					this.fApi.setValue('customername',e.data.name)
					this.fApi.setValue('invoicetitle',e.data.title)
					this.fApi.setValue('invoicetaxid',e.data.taxid)
					this.fApi.setValue('addresseeemail',e.data.email)
					if(customercode!=e.data.code){
						this.customercodeChange()
					}
					this.loading = true
					this.$api.collection.listTradesnew({
						mode: 'box',
						index: 0,
						customerid:e.data.id
					}).then((res) => {
						let target = res.list.find((item)=>{
							return item.needamount == this.fApi.getValue('amount') && !item.skcode
						})
						if(target){
							target.account = this.fApi.getValue('account')
							target.collection_time = this.fApi.getValue('commit_time')
							target.payman = this.fApi.getValue('invoicetitle')?this.fApi.getValue('invoicetitle'):'个人'
							target.orderamount = target.needamount				
							target.autoaudit = 5
							let $son_collection_order = this.fApi.el('$son_collection_order')
							let fullData = $son_collection_order.getGrid().getTableData().fullData
							let exist = fullData.find((item) => {
								return item.ordercode == target.ordercode
							})
							if(!exist){
								$son_collection_order.getGrid().insertAt(target, -1)
							}							
						}
						this.loading = false
					}, () => {
						this.loading = false
					})					
				}
			},
			customercodeButton(){
				this.condition = this.fApi.getValue('customercode')
				if(!this.condition){
					this.condition = this.fApi.getValue('mark')
				}
				
				this.$nextTick(()=>{
					this.$refs.customerbox.list_init()
					this.$refs.customerbox.modal_show()
				})
				
			
			},
			customercodeChange(){
				let $son_collection_order = this.fApi.el('$son_collection_order')
				$son_collection_order.clear()
			},
			tablefieldButtonclick(e){
				if(e.data.column.field == 'ordercode'){
					let message = '销售订单号'
					let title = '输入'
					let option = {
						distinguishCancelAndClose: true,
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						closeOnClickModal: false
					}
					this.$prompt(message, title, option).then((res) => {
						this.listTrades(res.value,{type:'order'}).then((res) => {
							// let data = {}
							let fatherOrderCode =[]
							fatherOrderCode = this.findFather(res[0].logs)
							// if( res[0].tp_type != 50){
							// 	this.$message.error('该订单为线上订单，无法创建收款单，请录入线下订单号。')
							// 	return
							// }
							e.data.row.ordercode = res[0].salercpt_no
							e.data.row.parentordercode = fatherOrderCode ? fatherOrderCode : res[0].salercpt_no
							e.data.row.isfirstbuy = res[0].isfirstbuy
							e.data.row.orderid = res[0].orderid
							if(res[0].sys_shop == 'DEB89560DE173D20AE4FDF382D5A741A'){
								e.data.row.shop = 7970
							}
							if(res[0].sys_shop == '89F39D3707C334B0A9778AE0F9398D1A'){
								e.data.row.shop = 7971
							}
							this.$nextTick(() => {
								this.getAmount()
							})
						})

						//console.log(res,e)

					}).catch(() => {

					})
				}
			},
			tableAdd(e) {
				if(e.moduleName == 'collection_order'){
					this.tradeboxHandle = e
					let customerid  =this.fApi.getValue('customerid')
					if(!customerid){
						this.$message.error('请选择客户')
						return
					}
					this.customerid = customerid
					this.$nextTick(()=>{
						this.$refs.tradebox.initList()
						this.$refs.tradebox.box.alertBox()
					})
					return
				}


				let message = '销售订单号'
				let title = '输入'
				let option = {
					distinguishCancelAndClose: true,
					confirmButtonText: '确定',
					cancelButtonText: '暂无',
					closeOnClickModal: false
				}
				if(e.moduleName == 'collection_exchange'){
					message = '售后单号'
				}
				if(this.device!='pc'){
					//message = <input placeholder={message}></input>
					option.beforeClose = (action, done)=>{
						this.alterCheckOrder(e,action, null, done)
					}
				}else{
					option.beforeClose = (action, instance, done)=>{
						this.alterCheckOrder(e,action, instance, done)
					}
				}
				this.$prompt(message, title, option).then(() => {
					e.next()
					this.$nextTick(() => {
						this.getAmount()
					})
				}).catch(() => {
					if(e.moduleName == 'collection_order'){
						e.next()
					}
				})
			},
			tradeboxSubmit(e){
				// console.log(e)
				e.data.forEach((item)=>{
					item.account = this.fApi.getValue('account')
					item.collection_time = this.fApi.getValue('commit_time')
					item.payman = this.fApi.getValue('invoicetitle')?this.fApi.getValue('invoicetitle'):'个人'
					item.orderamount = item.needamount				
					item.autoaudit = 5
				})
				this.tradeboxHandle.obj = e.data
				this.tradeboxHandle.next()
				this.$nextTick(()=>{
					this.getAmount()
				})
				// e.next()
				// this.$nextTick(() => {
				// 	this.getAmount()
				// })
			},
			unstandardChange(e){
				if(this.id && !this.randerformdata){
					this.$api.collection.updatefield(this.id, {
						unstandard: e
					}).then(()=>{
						this.$message.success('修改成功')
					})
				}
				//console.log(e)
			},
			invoicetaxidButton() {
				let invoicetaxid = this.fApi.getValue('invoicetaxid')
				if (invoicetaxid) {
					this.$api.invoiceoutput.searchinvoicetaxid(invoicetaxid).then((res) => {
						if (!res) {
							this.$message.error('暂无企业信息')
						} else {
							for (let i in res) {
								this.fApi.setValue(i, res[i])
							}
							//this.fApi.setValue(this.getItemValue(res.data[0]))
						}
			
					})
				} else {
					this.$message.error('请填企业税号')
				}
			},
			invoicetitleButton() {
				let invoicetitle = this.fApi.getValue('invoicetitle')
				if (invoicetitle) {
					this.$api.invoiceoutput.searchinvoicetaxid(0,{invoicetitle:invoicetitle}).then((res) => {
						if (!res) {
							this.$message.error('暂无企业信息')
						} else {
							for (let i in res) {
								this.fApi.setValue(i, res[i])
							}
							//this.fApi.setValue(this.getItemValue(res.data[0]))
						}
			
					})
				} else {
					this.$message.error('请填企业税号')
				}
			},
			checkonline_collection_order(){
				this.$refs.onlinebox.initList()
				this.$refs.onlinebox.box.alertBox()
			},
			checkonlineSubmit(e){
				// console.log(e)
				let $son_collection_order = this.fApi.el('$son_collection_order')
	
				let newdata = []
				e.data.forEach((item)=>{
					let obj = {
						ordercode:item.salercpt_no,
						payman:item.show_buyer,
						orderamount:item.tp_payment,
						needamount:item.tp_payment,
						autoaudit:5,
						collection_time:new Date().getTime()
					}
					newdata.push(obj)
				})

				$son_collection_order.getGrid().insertAt(newdata, -1).then((e) => {
					console.log(e)
					e.rows.forEach((row)=>{
						
						this.synchronous(row.ordercode,row)
					})

				})
	
			},
			findFather(logs) {
				let keyword = '父单号：'
				if (!(logs && logs.length)) {
					return false
				}
				let father = logs.filter((item) => {
					return item.logContent.includes(keyword)
				})
				if (father.length == 0) {
					return false
				}
				let keywordIndex = father[0].logContent.indexOf(keyword)
				let fatherOrderCode = father[0].logContent.substring(keywordIndex + keyword.length)
				if (!fatherOrderCode) {
					return false
				}
				return fatherOrderCode
			},
			beforeSubmit(formData, next) {
				let needamount = 0
				let $son_collection_order = this.fApi.el('$son_collection_order')
				let fullData = $son_collection_order.getGrid().getTableData().fullData
				fullData.forEach((item) => {
					needamount = needamount + parseFloat(item.needamount)
				})
				
				this.collection_timeChange()
		
				if(this.id!=0){
					if(this.fApi.getValue('amount') != this.getAmount()){
						this.$message.error('主表收款金额与明细收款总金额不相等')
					}else if( this.fApi.getValue('unstandardamount') > needamount ){
						this.$message.error('非标金额不能大于应收款金额')
					}else{
						next()
					}
				}else{
					next()
				}

				
			},
			amountChange(){
				let amount = this.fApi.getValue('amount')
				amount = amount?parseFloat(amount):0
				let refund = this.fApi.getValue('refund')
				refund = refund?parseFloat(refund):0
				this.fApi.setValue('resultamount',(amount - refund).toFixed(4))
			},
			tablefieldChange() {
				this.getAmount()
			},
			aftertabledelete() {
				this.getAmount()
			},
			getAmount() {
				let $son_collection_order = this.fApi.el('$son_collection_order')
				let table = $son_collection_order.getGrid()
				let fullData = table.getTableData().fullData
				let amount = 0
				fullData.forEach((item) => {
					amount += parseFloat(item.orderamount?item.orderamount:0)
				})
				

				let $son_collection_exchange = this.fApi.el('$son_collection_exchange')
				let exchangetable = $son_collection_exchange.getGrid()
				let exchangeData = exchangetable.getTableData().fullData
				let exchangeamount = 0
				exchangeData.forEach((item) => {
					exchangeamount += parseFloat(item.exchangeamount?item.exchangeamount:0)
				})
				this.fApi.setValue('refund', exchangeamount)
				this.amountChange()
				
				//this.fApi.setValue('amount', amount)
				return amount.toFixed(4)
			},
			collection_timeChange() {
				// let collection_time = this.fApi.getValue('collection_time')
				let $son_collection_order = this.fApi.el('$son_collection_order')
				let fullData = $son_collection_order.getGrid().getTableData().fullData
				fullData.forEach((item) => {
					//item.collection_time = collection_time
					item.staffid = this.$store.state.system.user.id
					item.departmentid = this.$store.state.system.user.departmentid
				})
			},
			regestEvent(rule, fApi) {

				let $son_collection_order = fApi.el('$son_collection_order')
				//console.log($son_collection_order)
				$son_collection_order.reconciliation = (row) => {
					let parentordercode = row.parentordercode
					if (parentordercode) {
						this.reconciliation(parentordercode, row)
					} else {
						this.$confirm('获取父级订单不存在，是否同步', '提示', {
							confirmButtonText: '是',
							cancelButtonText: '否',
							type: 'warning'
						}).then(() => {
							this.synchronous(row.ordercode,row)
						}).catch(() => {

						})

					}
				}
				$son_collection_order.synchronous = (row)=>{
					this.synchronous(row.ordercode,row)
				}
				
				$son_collection_order.gridOptions.showFooter = true
				$son_collection_order.footerField = [{
					type: 'seq',
					field: 'code',
					title: '汇总',
				}, {
					type: 'field',
					field: 'orderamount',
					toFixed: 4
				}]
				
				
				// $son_collection_order.gridOptions.showFooter = true
				// $son_collection_order.footerField =  [{
				// 	field: 'orderamount',
				// 	toFixed: 4
				// }]
					
			},
			afterGet() {
				if(this.currentcontrollid==194){
					this.fApi.setValue('departmentid',this.$store.state.system.user.departmentid)
					this.fApi.setValue('staffid',this.$store.state.system.user.id)
				}
			},
			synchronous(ordercode,row){
				if (!ordercode) {
					this.$message.error('订单编码不存在')
					return
				}
				this.listTrades(ordercode).then((res) => {
					if (res) {
						let fatherOrderCode = this.findFather(res[0].logs)
						row.parentordercode = fatherOrderCode ? fatherOrderCode : res[0]
							.salercpt_no
						row.outboundid = res[0].outbound && res[0].outbound.length != 0 ?
							res[0].outbound[0].billID :
							null
						row.outboundcode = res[0].outbound && res[0].outbound.length != 0 ?
							res[0].outbound[0].billCode :
							null
						row.needamount = res[0].real_payment
						if(row.id){
							this.$api.collection.updateCollectionOrder(row.id, {
								parentordercode: row.parentordercode,
								outboundid: row.outboundid,
								outboundcode: row.outboundcode,
								needamount: row.needamount
							})
						}
					}
				})
			},
			reconciliation(parentordercode) {
				let $son_collection_order = this.fApi.el('$son_collection_order')
				let fullData = $son_collection_order.getGrid().getTableData().fullData
				this.listTrades(parentordercode).then((res) => {
					this.$refs.reconciliation.wlnorder = res[0]
					this.$api.collection.getReceivedpayment(parentordercode).then((res) => {
						this.$refs.reconciliation.parentordercode = parentordercode
						this.$refs.reconciliation.erporder = res
						this.$refs.reconciliation.tableorder = fullData
						this.$refs.reconciliation.code = this.fApi.getValue('code')
						this.$refs.reconciliation.modalshow()
					})
				})
			},
			

			alterCheckOrder(e,action, instance, done){
				if (action == 'cancel') {
					done()
				}
				if (action == 'close') {
					e.obj = null
					done()
				}
				if (action == 'confirm') {
					if (this.loading) {
						this.$message({
							message: '正在查询，请稍后',
							type: 'warning'
						})
						return
					}
					if(instance){
						let type = e.moduleName == 'collection_exchange'?'exchange':'order'
						this.listTrades(instance.inputValue,{type:type}).then((res) => {
							let obj = []
							let data = {}
							let fatherOrderCode =[]
							if(type=='order'){
								fatherOrderCode = this.findFather(res[0].logs)
								// if( res[0].tp_type != 50){
								// 	this.$message.error('该订单为线上订单，无法创建收款单，请录入线下订单号。')
								// 	e.obj = null
								// 	done()
								// 	return
								// }
								data = {
									parentordercode: fatherOrderCode ? fatherOrderCode : res[0]
										.salercpt_no,
									ordercode: res[0].salercpt_no,
									orderid: res[0].salercpt_uid,
									isfirstbuy: res[0].isfirstbuy,			
									orderamount: 0,
									needamount: res[0].real_payment,
									outboundcode: res[0].outbound && res[0].outbound.length !=
										0 ? res[0].outbound[0]
										.billCode : null,
									outboundid: res[0].outbound && res[0].outbound.length !=
										0 ? res[0].outbound[0].billID : null
								}
								if(res[0].sys_shop == 'DEB89560DE173D20AE4FDF382D5A741A'){
									data.shop = 7970
								}
								if(res[0].sys_shop == '89F39D3707C334B0A9778AE0F9398D1A'){
									data.shop = 7971
								}
								if(res[0].exchange && res[0].exchange.length !=0){
									let $son_collection_exchange = this.fApi.el('$son_collection_exchange')
									let exchange = []
									res[0].exchange.forEach((item)=>{
										exchange.push({
											exchangeorderid:item.exchange_uid,
											exchangeordercode:item.exchange_no,
											ordercode:item.trade_no,
											exchangeamount:item.receivable_fee?item.receivable_fee:0,
											mark:item.reason_detail,
										})
									})
									
									$son_collection_exchange.getGrid().insertAt(exchange, -1)
								}

							}
							if(type=='exchange'){
								data = {
									exchangeorderid: res[0].exchange_uid,
									exchangeordercode: res[0].exchange_no,
									ordercode: res[0].trade_no,
									exchangeamount: res[0].receivable_fee?res[0].receivable_fee:0,
									mark: res[0].reason_detail,	
								}
							}
							obj.push(data)
							e.obj = obj
							done()
						})
					}else{
						this.$message.error('请输入单号')
	
					}

				}
			},
			
			
			listTrades(ordercode,data={}) {
				let loadhandle =  this.$loading(this.$refs[this.name+'_form'])
				return new Promise((reslove) => {
					this.$api.collection.listTrades(ordercode,data).then((res) => {
						let data = res.data
						if (data.length == 0) {
							this.$message.error('暂无订单信息')
						} else {
							this.$loadingclose(loadhandle)
							reslove(data)
						}
					}, () => {
						reslove(null)
						this.$loadingclose(loadhandle)
					})
				})
			}
		},
		components: {
			onlinebox,
			customerbox,
			tradebox
		}
	}
</script>
